.grid-with-banner {
  height: calc(100% - 45px);
}

.grid-without-banner {
  height: 100%;
}

.placeholder-with-demo-order {
  inset: 70px 0 0;
}
.placeholder-in-demo-store {
  inset: 0;
}
